import React, {use, useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../config.js';
import { Login } from '../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import Mask from './components/MaskAnimation.js';
//
import Home1 from '../components/home/Home1.js';
import Home2 from '../components/home/Home2.js';
import Home3 from '../components/home/Home3.js'
import Home4 from '../components/home/Home4.js';
import Home5 from '../components/home/Home5.js';
import Home6 from '../components/home/Home6.js';
import Footer from './components/Footer.js';


function Component(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    
    return(
        <div className='bg-white w-full flex flex-col'>
            <Home1 scrollY={props.scrollY} scrollRef={props.scrollRef}/>
            <Home2 />
            <Home3 />
            <Home4 />
            <Home5 />
            <Home6 />
            <Footer />
            <Mask />
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)